import { useQuery } from "@tanstack/react-query";
import { CompanyDetailDto, UserProfileDto, UserRole } from "@green0meter/api-client";

import { DOMAIN_COMPANIES } from "../domain";

import { companiesApi } from "@api/services";
import { TANSTACK_QUERY_STALE_TIME } from "@constants";
import { roleGuard } from "@api";

export const ACTION_GET_COMPANY_DETAIL = "GET_COMPANY_DETAIL";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

interface GetCompanyDetailProps {
  companyId: string | undefined;
}

const getCompanyDetail = async (
  props: GetCompanyDetailProps,
): Promise<CompanyDetailDto> => {
  const { companyId = "" } = props;

  const response = await companiesApi.companiesControllerGetCompanyDetail(companyId);

  return response.data;
};

export const useGetCompanyDetail = (
  props: GetCompanyDetailProps,
  user: UserProfileDto | null,
): {
  companyDetail?: CompanyDetailDto;
  companyDetailEnabled: boolean;
  isLoadingGetCompanyDetail: boolean;
  isFetchingGetCompanyDetail: boolean;
  isSuccessGetCompanyDetail: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const { isLoading, isFetching, data, isSuccess } = useQuery({
    queryKey: [DOMAIN_COMPANIES, ACTION_GET_COMPANY_DETAIL, props],
    queryFn: () => getCompanyDetail(props),
    enabled: Boolean(props.companyId) && enabled,
    staleTime: TANSTACK_QUERY_STALE_TIME,
  });

  return {
    companyDetail: data,
    companyDetailEnabled: enabled,
    isLoadingGetCompanyDetail: isLoading,
    isFetchingGetCompanyDetail: isFetching,
    isSuccessGetCompanyDetail: isSuccess,
  };
};
